(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sensei-slider-dete"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sensei-dete-reveal')) {
  customElements.define('sensei-dete-reveal', class extends HTMLElement {
    connectedCallback() {
      this.startFrame=requestAnimationFrame(()=>{ if(this.isConnected) this.mount(); });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      if(this.stopAnimation)this.stopAnimation();
      if(this.cleanup)this.cleanup.abort();
    }
    mount() {
      if(!this.querySelector('.sv-range'))return;
      if(this.cleanup)this.cleanup.abort();
      if(this.stopAnimation)this.stopAnimation();
    const root=this;
    const stage=root.querySelector('.sv-stage');
    const range=root.querySelector('.sv-range');
    const toggle=root.querySelector('.sv-toggle');
    const cleanup=new AbortController();
    this.cleanup=cleanup;
    const on=(element,type,handler)=>element.addEventListener(type,handler,{signal:cleanup.signal});
    const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
    let playing=root.dataset.autoplay==='true' && !reduce.matches,raf=0,start=null,from=50;
    function show(p){
      const value=Math.max(0,Math.min(100,p));
      stage.style.setProperty('--sv-position',value+'%');range.value=value;
      range.setAttribute('aria-valuetext',Math.round(value)+'% fotografija, '+Math.round(100-value)+'% Sensei');
    }
    function button(){
      toggle.setAttribute('aria-label',playing?'Pauziraj animaciju':'Pokreni animaciju');
      toggle.querySelector('[data-play-label]').textContent=playing?'Pauza':'Pokreni';
      toggle.querySelector('svg').style.display=playing?'block':'none';
    }
    const ease=x=>x*x*(3-2*x);
    function tick(now){
      if(!playing)return;
      if(start===null)start=now;
      const elapsed=(now-start)*1.35;
      if(elapsed<800)show(from+(100-from)*ease(elapsed/800));
      else {
        const t=(elapsed-800)%7200;
        if(t<1000)show(100);
        else if(t<2800)show(100*(1-ease((t-1000)/1800)));
        else if(t<4600)show(0);
        else if(t<6400)show(100*ease((t-4600)/1800));
        else show(100);
      }
      raf=requestAnimationFrame(tick);
    }
    function pause(){playing=false;cancelAnimationFrame(raf);button();}
    let dragging=null;
    function positionFromPointer(e){
      const bounds=stage.getBoundingClientRect();
      if(bounds.width>0)show((e.clientX-bounds.left)/bounds.width*100);
    }
    on(range,'pointerdown',e=>{
      if(e.isPrimary===false || e.button!==0)return;
      e.preventDefault();
      pause();dragging=e.pointerId;
      range.focus({preventScroll:true});
      range.setPointerCapture(e.pointerId);
      positionFromPointer(e);
    });
    on(range,'pointermove',e=>{
      if(e.pointerId!==dragging)return;
      e.preventDefault();positionFromPointer(e);
    });
    function endDrag(e){
      if(e.pointerId!==dragging)return;
      if(e.type==='pointerup')positionFromPointer(e);
      dragging=null;
      if(range.hasPointerCapture(e.pointerId))range.releasePointerCapture(e.pointerId);
    }
    on(range,'pointerup',endDrag);
    on(range,'pointercancel',endDrag);
    on(range,'lostpointercapture',()=>{dragging=null;});
    on(range,'input',()=>{pause();show(Number(range.value));});
    on(toggle,'click',()=>{
      if(playing)pause();
      else {playing=true;start=null;from=Number(range.value);button();raf=requestAnimationFrame(tick);}
    });
    on(reduce,'change',e=>{if(e.matches)pause();});
    this.stopAnimation=()=>{playing=false;cancelAnimationFrame(raf);};
    show(50);button();
    if(playing)raf=requestAnimationFrame(tick);

    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sensei-slider-ljubimac"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sensei-ljubimac-reveal')) {
  customElements.define('sensei-ljubimac-reveal', class extends HTMLElement {
    connectedCallback() {
      this.startFrame=requestAnimationFrame(()=>{ if(this.isConnected) this.mount(); });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      if(this.stopAnimation)this.stopAnimation();
      if(this.cleanup)this.cleanup.abort();
    }
    mount() {
      if(!this.querySelector('.sv-range'))return;
      if(this.cleanup)this.cleanup.abort();
      if(this.stopAnimation)this.stopAnimation();
    const root=this;
    const stage=root.querySelector('.sv-stage');
    const range=root.querySelector('.sv-range');
    const toggle=root.querySelector('.sv-toggle');
    const cleanup=new AbortController();
    this.cleanup=cleanup;
    const on=(element,type,handler)=>element.addEventListener(type,handler,{signal:cleanup.signal});
    const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
    let playing=root.dataset.autoplay==='true' && !reduce.matches,raf=0,start=null,from=50;
    function show(p){
      const value=Math.max(0,Math.min(100,p));
      stage.style.setProperty('--sv-position',value+'%');range.value=value;
      range.setAttribute('aria-valuetext',Math.round(value)+'% fotografija, '+Math.round(100-value)+'% Sensei');
    }
    function button(){
      toggle.setAttribute('aria-label',playing?'Pauziraj animaciju':'Pokreni animaciju');
      toggle.querySelector('[data-play-label]').textContent=playing?'Pauza':'Pokreni';
      toggle.querySelector('svg').style.display=playing?'block':'none';
    }
    const ease=x=>x*x*(3-2*x);
    function tick(now){
      if(!playing)return;
      if(start===null)start=now;
      const elapsed=(now-start)*1.35;
      if(elapsed<800)show(from+(100-from)*ease(elapsed/800));
      else {
        const t=(elapsed-800)%7200;
        if(t<1000)show(100);
        else if(t<2800)show(100*(1-ease((t-1000)/1800)));
        else if(t<4600)show(0);
        else if(t<6400)show(100*ease((t-4600)/1800));
        else show(100);
      }
      raf=requestAnimationFrame(tick);
    }
    function pause(){playing=false;cancelAnimationFrame(raf);button();}
    let dragging=null;
    function positionFromPointer(e){
      const bounds=stage.getBoundingClientRect();
      if(bounds.width>0)show((e.clientX-bounds.left)/bounds.width*100);
    }
    on(range,'pointerdown',e=>{
      if(e.isPrimary===false || e.button!==0)return;
      e.preventDefault();
      pause();dragging=e.pointerId;
      range.focus({preventScroll:true});
      range.setPointerCapture(e.pointerId);
      positionFromPointer(e);
    });
    on(range,'pointermove',e=>{
      if(e.pointerId!==dragging)return;
      e.preventDefault();positionFromPointer(e);
    });
    function endDrag(e){
      if(e.pointerId!==dragging)return;
      if(e.type==='pointerup')positionFromPointer(e);
      dragging=null;
      if(range.hasPointerCapture(e.pointerId))range.releasePointerCapture(e.pointerId);
    }
    on(range,'pointerup',endDrag);
    on(range,'pointercancel',endDrag);
    on(range,'lostpointercapture',()=>{dragging=null;});
    on(range,'input',()=>{pause();show(Number(range.value));});
    on(toggle,'click',()=>{
      if(playing)pause();
      else {playing=true;start=null;from=Number(range.value);button();raf=requestAnimationFrame(tick);}
    });
    on(reduce,'change',e=>{if(e.matches)pause();});
    this.stopAnimation=()=>{playing=false;cancelAnimationFrame(raf);};
    show(50);button();
    if(playing)raf=requestAnimationFrame(tick);

    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sensei-slider-porodica"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sensei-porodica-reveal')) {
  customElements.define('sensei-porodica-reveal', class extends HTMLElement {
    connectedCallback() {
      this.startFrame=requestAnimationFrame(()=>{ if(this.isConnected) this.mount(); });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      if(this.stopAnimation)this.stopAnimation();
      if(this.cleanup)this.cleanup.abort();
    }
    mount() {
      if(!this.querySelector('.sv-range'))return;
      if(this.cleanup)this.cleanup.abort();
      if(this.stopAnimation)this.stopAnimation();
    const root=this;
    const stage=root.querySelector('.sv-stage');
    const range=root.querySelector('.sv-range');
    const toggle=root.querySelector('.sv-toggle');
    const cleanup=new AbortController();
    this.cleanup=cleanup;
    const on=(element,type,handler)=>element.addEventListener(type,handler,{signal:cleanup.signal});
    const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
    let playing=root.dataset.autoplay==='true' && !reduce.matches,raf=0,start=null,from=50;
    function show(p){
      const value=Math.max(0,Math.min(100,p));
      stage.style.setProperty('--sv-position',value+'%');range.value=value;
      range.setAttribute('aria-valuetext',Math.round(value)+'% fotografija, '+Math.round(100-value)+'% Sensei');
    }
    function button(){
      toggle.setAttribute('aria-label',playing?'Pauziraj animaciju':'Pokreni animaciju');
      toggle.querySelector('[data-play-label]').textContent=playing?'Pauza':'Pokreni';
      toggle.querySelector('svg').style.display=playing?'block':'none';
    }
    const ease=x=>x*x*(3-2*x);
    function tick(now){
      if(!playing)return;
      if(start===null)start=now;
      const elapsed=(now-start)*1.35;
      if(elapsed<800)show(from+(100-from)*ease(elapsed/800));
      else {
        const t=(elapsed-800)%7200;
        if(t<1000)show(100);
        else if(t<2800)show(100*(1-ease((t-1000)/1800)));
        else if(t<4600)show(0);
        else if(t<6400)show(100*ease((t-4600)/1800));
        else show(100);
      }
      raf=requestAnimationFrame(tick);
    }
    function pause(){playing=false;cancelAnimationFrame(raf);button();}
    let dragging=null;
    function positionFromPointer(e){
      const bounds=stage.getBoundingClientRect();
      if(bounds.width>0)show((e.clientX-bounds.left)/bounds.width*100);
    }
    on(range,'pointerdown',e=>{
      if(e.isPrimary===false || e.button!==0)return;
      e.preventDefault();
      pause();dragging=e.pointerId;
      range.focus({preventScroll:true});
      range.setPointerCapture(e.pointerId);
      positionFromPointer(e);
    });
    on(range,'pointermove',e=>{
      if(e.pointerId!==dragging)return;
      e.preventDefault();positionFromPointer(e);
    });
    function endDrag(e){
      if(e.pointerId!==dragging)return;
      if(e.type==='pointerup')positionFromPointer(e);
      dragging=null;
      if(range.hasPointerCapture(e.pointerId))range.releasePointerCapture(e.pointerId);
    }
    on(range,'pointerup',endDrag);
    on(range,'pointercancel',endDrag);
    on(range,'lostpointercapture',()=>{dragging=null;});
    on(range,'input',()=>{pause();show(Number(range.value));});
    on(toggle,'click',()=>{
      if(playing)pause();
      else {playing=true;start=null;from=Number(range.value);button();raf=requestAnimationFrame(tick);}
    });
    on(reduce,'change',e=>{if(e.matches)pause();});
    this.stopAnimation=()=>{playing=false;cancelAnimationFrame(raf);};
    show(50);button();
    if(playing)raf=requestAnimationFrame(tick);

    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sensei-slider-vas-dvoje"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sensei-vas-dvoje-reveal')) {
  customElements.define('sensei-vas-dvoje-reveal', class extends HTMLElement {
    connectedCallback() {
      this.startFrame=requestAnimationFrame(()=>{ if(this.isConnected) this.mount(); });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      if(this.stopAnimation)this.stopAnimation();
      if(this.cleanup)this.cleanup.abort();
    }
    mount() {
      if(!this.querySelector('.sv-range'))return;
      if(this.cleanup)this.cleanup.abort();
      if(this.stopAnimation)this.stopAnimation();
    const root=this;
    const stage=root.querySelector('.sv-stage');
    const range=root.querySelector('.sv-range');
    const toggle=root.querySelector('.sv-toggle');
    const cleanup=new AbortController();
    this.cleanup=cleanup;
    const on=(element,type,handler)=>element.addEventListener(type,handler,{signal:cleanup.signal});
    const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
    let playing=root.dataset.autoplay==='true' && !reduce.matches,raf=0,start=null,from=50;
    function show(p){
      const value=Math.max(0,Math.min(100,p));
      stage.style.setProperty('--sv-position',value+'%');range.value=value;
      range.setAttribute('aria-valuetext',Math.round(value)+'% fotografija, '+Math.round(100-value)+'% Sensei');
    }
    function button(){
      toggle.setAttribute('aria-label',playing?'Pauziraj animaciju':'Pokreni animaciju');
      toggle.querySelector('[data-play-label]').textContent=playing?'Pauza':'Pokreni';
      toggle.querySelector('svg').style.display=playing?'block':'none';
    }
    const ease=x=>x*x*(3-2*x);
    function tick(now){
      if(!playing)return;
      if(start===null)start=now;
      const elapsed=(now-start)*1.35;
      if(elapsed<800)show(from+(100-from)*ease(elapsed/800));
      else {
        const t=(elapsed-800)%7200;
        if(t<1000)show(100);
        else if(t<2800)show(100*(1-ease((t-1000)/1800)));
        else if(t<4600)show(0);
        else if(t<6400)show(100*ease((t-4600)/1800));
        else show(100);
      }
      raf=requestAnimationFrame(tick);
    }
    function pause(){playing=false;cancelAnimationFrame(raf);button();}
    let dragging=null;
    function positionFromPointer(e){
      const bounds=stage.getBoundingClientRect();
      if(bounds.width>0)show((e.clientX-bounds.left)/bounds.width*100);
    }
    on(range,'pointerdown',e=>{
      if(e.isPrimary===false || e.button!==0)return;
      e.preventDefault();
      pause();dragging=e.pointerId;
      range.focus({preventScroll:true});
      range.setPointerCapture(e.pointerId);
      positionFromPointer(e);
    });
    on(range,'pointermove',e=>{
      if(e.pointerId!==dragging)return;
      e.preventDefault();positionFromPointer(e);
    });
    function endDrag(e){
      if(e.pointerId!==dragging)return;
      if(e.type==='pointerup')positionFromPointer(e);
      dragging=null;
      if(range.hasPointerCapture(e.pointerId))range.releasePointerCapture(e.pointerId);
    }
    on(range,'pointerup',endDrag);
    on(range,'pointercancel',endDrag);
    on(range,'lostpointercapture',()=>{dragging=null;});
    on(range,'input',()=>{pause();show(Number(range.value));});
    on(toggle,'click',()=>{
      if(playing)pause();
      else {playing=true;start=null;from=Number(range.value);button();raf=requestAnimationFrame(tick);}
    });
    on(reduce,'change',e=>{if(e.matches)pause();});
    this.stopAnimation=()=>{playing=false;cancelAnimationFrame(raf);};
    show(50);button();
    if(playing)raf=requestAnimationFrame(tick);

    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
